import React, { useEffect, useState } from 'react';

import { TimezoneAbbreviationEnum } from '_lib/api/apiTypes.shim';
import { Typography, TypographyProps } from '_lib/components/Typography/Typography';

import { DateFormatEnum, DateUtils } from '_lib/utils/date.utils';

export interface CompanyClockProps extends TypographyProps {
  timezone: TimezoneAbbreviationEnum;
}

export const CompanyClock = (props: CompanyClockProps): React.ReactElement => {
  const { timezone, ...typographyProps } = props;

  const [currentCompanyTime, setCurrentCompanyTime] = useState<Date>(new Date());

  useEffect(() => {
    // Calculate the number of milliseconds until the top of the next minute.
    const topOfMinuteOffset = (60 - currentCompanyTime.getSeconds()) * 1000 - currentCompanyTime.getMilliseconds();

    // Start polling for the current time, starting at the top of the next minute.
    const timeout = setTimeout(() => {
      setCurrentCompanyTime(new Date());
    }, topOfMinuteOffset);

    // Stop the timer when the component is unmounted.
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [currentCompanyTime]);

  return (
    <Typography
      {...typographyProps}
      text={DateUtils.format(currentCompanyTime, DateFormatEnum.Time, { timezone, showTimezone: true })}
    />
  );
};
